import { z, isoZ } from 'my-zod'

export const tableViewsModel = z.object({
  id: z.string(),
  tableName: z.string(),
  viewName: z.string(),
  ownerId: z.number(),
  order: z.string().array(),
  sorting: z
    .object({
      columnName: z.string(),
      direction: z.enum(['asc', 'desc'])
    })
    .array(),
  columnWidths: z
    .object({
      columnName: z.string(),
      width: z.number()
    })
    .array(),
  filters: z
    .object({
      columnName: z.string(),
      operation: z.string().optional(),
      value: z.any()
    })
    .array()
    .optional(),
  search: z.string().optional(),
  grouping: z
    .object({
      columnName: z.string()
    })
    .array()
    .optional(),
  visibleColumns: z.string().array().optional(),
  summaries: z
    .object({
      columnName: z.string(),
      type: z.string(),
      showInGroupFooter: z.boolean().nullish(),
      alignByColumn: z.boolean().nullish()
    })
    .array()
    .optional(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export type tableViewsModel = z.infer<typeof tableViewsModel>
